import apiInstance from "services/api/api";
import { IUserGetOrder } from "shared/interfaces/Order.interface";

export default (orderId: string) =>
  apiInstance
    .get<{ data: IUserGetOrder }>(`/orders/${orderId}`)
    .then((res) => res.data);
